'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumber$() {
  this.aJ5 = null;
  this.aJ6 = false;
  this.aJ3 = null;
  this.aJ4 = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumber$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumber$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumber$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumber$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumber$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumber$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumber$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumber$.prototype = $p;
$p.aA = (function() {
  if ((!this.aJ6)) {
    this.aJ5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aJ6 = true;
  }
  return this.aJ5;
});
$p.aso = (function() {
  if ((!this.aJ4)) {
    this.aJ3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeString__given_Ordering_Type__s_math_Ordering(this);
    this.aJ4 = true;
  }
  return this.aJ3;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumber$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumber$, "app.data.data_point_types$package$DocumentNumber$", ({
  FH: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumber$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumber$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumber$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumber$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumber$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumber$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumber$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumber$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumber$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumber$ };
//# sourceMappingURL=app.data.data_point_types$package$-Document-Number$.js.map
